// extracted by css-extract-rspack-plugin
export default {"sidebar":"DashboardSidebar_mobile_sidebar__lue6W","desktopSections":"DashboardSidebar_mobile_desktopSections__jE3Dd"};